import React from 'react';
import SignupDialog from '../../Dialog/SignupDialog';
import Typography from '@material-ui/core/Typography';
import T from 'i18n-react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 'bold',
  },
  small: {
    fontSize: theme.typography.pxToRem(14),
  },
}));

type FollowDescDialogProps = {
  title?: string | boolean,
  text?: string | boolean,
  footer?: string | boolean,
};

const FollowDescDialog = React.forwardRef(
  ({ title, text, footer }: FollowDescDialogProps, ref) => {
    const classes = useStyles();

    return (
      <SignupDialog
        contentNode={
          <>
            {title !== false && (
              <Typography color="primary" className={classes.title}>
                {title || T.translate('dialogs.signup.followText1')}
              </Typography>
            )}
            {text !== false && (
              <Typography>
                {text || T.translate('dialogs.signup.followText2')}
              </Typography>
            )}
            {footer !== false && (
              <Typography className={classes.small}>
                {footer || T.translate('dialogs.signup.followText3')}
              </Typography>
            )}
          </>
        }
        ref={ref}
      />
    );
  },
);

export default FollowDescDialog;
